import Loading from "../../components/Common/Loading";
import UserSocialInfo from "./userSocialInfo";
import {useEffect, useState} from "react";
import {useGetUserInfoV1Query} from "../../core/api/bermuda-analytical-data-api";


const UserSocialInfoBA = (props) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUserInfoV1Query(props.deviceId)
    const [infoData, setInfoData] = useState("");

    useEffect(() => {
        setInfoData(data)

    }, [data])

    return (
        <Loading
            isLoading={isLoading}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {infoData && <UserSocialInfo
                data={infoData}

            />
            }
        </Loading>
    )
}

export default UserSocialInfoBA